import Lottie from 'lottie-react';
import findingPinInBoxAnimation from '../../../../../animations/finding-pin-in-box.json';
import './FindingPinInBox.scss';

export default function FindingPinInBox() {
  return (
    <div className="FindingPinInBox">
      <Lottie
        animationData={findingPinInBoxAnimation}
        loop
        autoplay
        style={{ aspectRatio: '1', height: '100%' }}
      />
    </div>
  );
}
